import Vue from 'vue'
import axios from 'axios';

//log geral

Vue.prototype.$listarLogGeral = async () => {
  try {
    let res = await axios.get('log/geral', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

//log Cidadao

Vue.prototype.$listarLogCidadao = async () => {
  try {
    let res = await axios.get('log/cidadao', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

//log Manifestacao

Vue.prototype.$listarLogManifestacao = async () => {
  try {
    let res = await axios.get('log/manifestacao', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

//log Movimentação de manifestações

Vue.prototype.$listarLogMovManifestacao = async () => {
  try {
    let res = await axios.get('log/movimentacao/manifestacao', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

Vue.prototype.$listarLogMovManifestacaoID = async (uuid) => {
  try {
    let res = await axios.get('log/movimentacao/'+uuid+'/manifestacao', {});
    return res.data;
  } catch (e) {
    throw e;
  }
}

